// Validation
import { URL_REGEX } from '../../../../../common/validation/validationConstants';
import { BOARD_NAME_URL_ERROR_MESSAGE_MOBILE, BOARD_NAME_URL_ERROR_MESSAGE_DESKTOP } from './boardSharingConstants';

/**
 * Returns an error message if the board title contains a URL, otherwise undefined
 * Accepts isMobile to allow custom error messages per platform
 */
export const validateBoardTitle = (title: string, isMobile?: boolean): string | undefined => {
    if (!title) return;

    const urlMatches = title.match(URL_REGEX);

    if (urlMatches && urlMatches.length > 0) {
        if (isMobile) {
            return BOARD_NAME_URL_ERROR_MESSAGE_MOBILE;
        }
        return BOARD_NAME_URL_ERROR_MESSAGE_DESKTOP;
    }
    return;
};
